import { PlpTypes } from 'lib/apis/services/PlpListing';

export const singleDynamicModle: {
  buy: PlpTypes.DynamicModelSinglePdp;
  rent: PlpTypes.DynamicModelSinglePdp;
} = {
  buy: {
    attributes: {
      chips: [
        {
          path: 'landuseType',
          default: '',
          prefix: '',
          suffix: '',
        },
        {
          path: 'propertyType',
          default: '',
          prefix: '',
          suffix: '',
        },
        {
          path: 'floorArea',
          default: '',
          prefix: '',
          suffix: 'متر',
        },
        {
          path: 'numBeds',
          default: '',
          prefix: '',
          suffix: 'خوابه',
        },
        {
          path: 'numParkings',
          default: '',
          prefix: '',
          suffix: 'پارکینگ',
        },
        // {
        //   path: 'age',
        //   default: '',
        //   prefix: '',
        //   suffix: 'ساله',
        // },
        {
          path: 'elevator',
          default: undefined,
          prefix: '',
          suffix: '',
        },
        {
          path: 'warehouse',
          default: undefined,
          prefix: '',
          suffix: '',
        },
        {
          path: 'newBuild',
          default: undefined,
          prefix: '',
          suffix: '',
        },
        {
          path: 'yearBuilt',
          default: undefined,
          prefix: 'سال ساخت ',
          suffix: '',
        },
      ],
    },
    pricing: {
      price: {
        path: 'pricing.price',
        default: 'توافقی',
        suffix: 'تومان',
      },
      unitPrice: {
        path: 'pricing.unitPrice',
        default: '',
        suffix: 'تومان',
      },
    },
    media: {
      pictures: {
        path: 'pictures',
        default: 'https://cdn.kilid.com/default-large.png',
        type: 'map',
        field: 'photoLargeUrl',
      },
      //   vrLink: {
      //     path: 'attributes.vrLink',
      //     default: '',
      //     suffix: '',
      //   },
    },
    title: {
      path: 'title',
      default: '',
    },
    date: {
      path: 'searchDate',
      default: '',
    },
    identifier: {
      path: 'id',
      default: '',
    },
    specifics: {
      path: 'features',
      default: '',
      type: 'map',
      field: 'type',
    },
    tags: {
      path: 'tags',
      default: '',
      type: 'map',
      field: 'type',
    },
    location: {
      locationName: {
        path: 'location',
        default: '',
      },
      staticMapUrl: {
        path: 'location.staticMapUrl',
        default: '',
      },
    },
    breadcrumbLinks: {
      links: [
        {
          path: 'breadcrumbLinks',
          default: '',
          type: 'map',
          field: 'linkUrl',
        },
        {
          path: 'breadcrumbLinks',
          default: '',
          type: 'map',
          field: 'name',
        },
      ],
    },
    description: {
      path: 'description',
      default: '',
    },
    // seoDescription: {
    //   path: 'seoDescription',
    //   default: '',
    // },
    // isApproximate: {
    //   path: 'isApproximate',
    //   default: '',
    // },
    // expired: {
    //   path: 'expired',
    //   default: '',
    // },
  },
  rent: {
    attributes: {
      chips: [
        {
          path: 'landuseType',
          default: '',
          prefix: '',
          suffix: '',
        },
        {
          path: 'propertyType',
          default: '',
          prefix: '',
          suffix: '',
        },
        {
          path: 'floorArea',
          default: '',
          prefix: '',
          suffix: 'متر',
        },
        {
          path: 'numBeds',
          default: '',
          prefix: '',
          suffix: 'خوابه',
        },
        {
          path: 'numParkings',
          default: '',
          prefix: '',
          suffix: 'پارکینگ',
        },
        // {
        //   path: 'age',
        //   default: '',
        //   prefix: '',
        //   suffix: 'ساله',
        // },
        {
          path: 'elevator',
          default: undefined,
          prefix: '',
          suffix: '',
        },
        {
          path: 'warehouse',
          default: undefined,
          prefix: '',
          suffix: '',
        },
        {
          path: 'newBuild',
          default: undefined,
          prefix: '',
          suffix: '',
        },
        {
          path: 'yearBuilt',
          default: undefined,
          prefix: 'سال ساخت ',
          suffix: '',
        },
      ],
    },
    pricing: {
      rent: {
        path: 'pricing.rent',
        default: '',
        suffix: 'تومان',
      },
      deposit: {
        path: 'pricing.deposit',
        default: 'توافقی',
        suffix: 'تومان',
      },
    },
    media: {
      pictures: {
        path: 'media',
        default: 'https://cdn.kilid.com/default-large.png',
        type: 'map',
        field: 'photoLargeUrl',
      },
      //   vrLink: {
      //     path: 'attributes.vrLink',
      //     default: '',
      //     suffix: '',
      //   },
    },
    title: {
      path: 'title',
      default: '',
    },
    date: {
      path: 'searchDate',
      default: '',
    },
    identifier: {
      path: 'identifier',
      default: '',
    },
    specifics: {
      path: 'features',
      default: '',
      type: 'map',
      field: 'type',
    },
    tags: {
      path: 'tags',
      default: '',
      type: 'map',
      field: 'type',
    },
    location: {
      locationName: {
        path: 'location',
        default: '',
      },
      staticMapUrl: {
        path: 'location.staticMapUrl',
        default: '',
      },
    },
    breadcrumbLinks: {
      links: [
        {
          path: 'breadcrumbLinks',
          default: '',
          type: 'map',
          field: 'linkUrl',
        },
        {
          path: 'breadcrumbLinks',
          default: '',
          type: 'map',
          field: 'name',
        },
      ],
    },
    description: {
      path: 'description',
      default: '',
    },
    // seoDescription: {
    //   path: 'seoDescription',
    //   default: '',
    // },
    // isApproximate: {
    //   path: 'isApproximate',
    //   default: '',
    // },
    // expired: {
    //   path: 'expired',
    //   default: '',
    // },
  },
};





